export enum DeliveryStatusEnum {
  Draft = 'draft',
  Sent = 'sent',
  Scheduled = 'scheduled'
}

export const DELIVERY_STATUS_ENUM_RECORD: Record<DeliveryStatusEnum, string> = {
  [DeliveryStatusEnum.Draft]: 'Draft',
  [DeliveryStatusEnum.Sent]: 'Sent',
  [DeliveryStatusEnum.Scheduled]: 'Scheduled'
};
